/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flexGrow: 1,
  padding: token('space.400'),
});

export const Header = styled.div({
  font: token('font.heading.xsmall'),
  marginTop: token('space.200'),
  alignItems: 'center',
  display: 'flex',
});

export const Title = styled.div({
  marginLeft: token('space.100'),
});

export const Description = styled.p({
  color: token('color.text.subtle'),
});
